angular
  .module 'gym.components'
  .directive 'changeTypeSelector', ->
    restrict: 'E'
    template: require('templates/components/calendar/change_type_selector.html.slim')
    scope:
      changeType: '@'
      changeVerb: '@'
      event: '='
